/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};



/******/ })()
;

$(document).ready(function(){
  w3js= $ 
   w3js( document ).ready(function() {
   w3productOptionsJS(w3js);
 });
  
   w3js('body').on("productOptionsLoaded", function() { 
     //console.log('loaded');
    w3js(".po-accordion-group.open").removeClass("open");
  }); 
	//$('po-accordion-group').onload
  //alert();
    $('.po-accordion-group').removeClass('open');
  
  $('.po-accordion-group').click(function(){
  		$('po-accordion-group').addClass('bg-black');
  });
 $('.responsive').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 3
            }
        }]
    });
$('#usf_container').addClass('container-fluid');
  
  
      setTimeout(
  function() 
  {
    $(".ly-breakpoint-2 .ly-flag-icon-en").addClass('enflag');
     $(".ly-breakpoint-2 .ly-flag-icon-ar").addClass('arflag');
  }, 500);
   
  
});
